var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraveTraveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 42.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.1943 27.275h7.4487v-14.897h-7.4487z",
    fill: "#008768"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.74487 0 0 .74487 14.272 27.275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4.946-7.27 17.786-12.721v1.229l-16.409 11.737 4.098 6.025h1.087l11.224-8.028v1.229l-10.903 7.799z",
    fill: "#008768"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.74487 0 0 .74487 8.125 27.275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-10.908-7.807v-1.231l11.229 8.038h1.085l4.097-6.025-16.399-11.736-.012.017v-1.255l17.786 12.729-4.942 7.27z",
    fill: "#008768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraveTraveIcon);
export default __webpack_public_path__ + "static/media/TraveTraveIcon.9c78dd6d6200f90c90856a1d761eb4a6.svg";
export { ForwardRef as ReactComponent };